import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const Caption = styled.p`
  ${tw`flex items-center text-caption text-textUltraLight m-0`};
  font-weight: normal;
`;

export default Caption;
